import {ApiArticlesGetExpectedData} from "@iw-shared/api/articles";

export interface ConfigState {
  productDBToken?: string;
  productDBCopyFields?: Array<keyof ApiArticlesGetExpectedData>;
}

export const initialConfigState = (): ConfigState | {} => {
  return { };
};
